<template>
  <div class="lib__text-center">
    <p>
      <img :src="require('@/assets/e-mobility/Icon-ErrorEAN.svg')" alt="no-result-icon">
    </p>
    <header class="lib__form__main__header">
      <h2 class="lib__h2">{{ $t('e-mobility.no-ean-result.apologieTitle') }}</h2>
    </header>
    <p v-if="stateGridAccessPointNokReason === 'missingInformation'"
      v-html="$t('e-mobility.no-ean-result.extraInfoPartMissingInformation', { EAN: getEanCode })"></p>
    <p v-if="stateGridAccessPointNokReason === 'moreThanOneMeter'"
      v-html="$t('e-mobility.no-ean-result.extraInfoPartMoreThanOneMeter', { EAN: getEanCode })"></p>
    <p v-if="stateGridAccessPointNokReason === 'notElectricityGridAccessPoint'"
      v-html="$t('e-mobility.no-ean-result.extraInfoPartNotElectricityGridAccessPoint', { EAN: getEanCode })"></p>
    <p v-if="stateGridAccessPointNokReason === 'eanNotFound'"
      v-html="$t('e-mobility.no-ean-result.extraInfoPartEanNotFound', { EAN: getEanCode })"></p>

    <p v-if="stateGridAccessPointNokReason === 'eanNotFound'"
      v-html="$t('e-mobility.no-ean-result.stepToBackOrFollow')"></p>
    <p v-else-if="stateGridAccessPointNokReason !== 'notElectricityGridAccessPoint'"
      v-html="$t('e-mobility.no-ean-result.stepToFollow')"></p>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter, State } from 'vuex-class'
@Component({
  name: 'no-ean-result'
})

export default class NoGridAccessPointInfo extends Vue {
  //#region [Data]
  @Getter('getEanCode', { namespace: 'eMobility/identification' })
  public getEanCode!: string

  @State('gridAccessPointNokReason', { namespace: 'eMobility/identification' })
  public stateGridAccessPointNokReason!: string
  //#endregion

  //#region [Watch]
  @Watch('stateGridAccessPointNokReason', { immediate: true })
  public onStateGridAccessPointNokReason(reason: string | null): void {
    this.$emit('canContinue', reason !== 'notElectricityGridAccessPoint')
  }
  //#endregion
}
</script>
